import { render, staticRenderFns } from "./NaviConfig.vue?vue&type=template&id=1db3a6d6"
import script from "./NaviConfig.vue?vue&type=script&lang=js"
export * from "./NaviConfig.vue?vue&type=script&lang=js"
import style0 from "./NaviConfig.vue?vue&type=style&index=0&id=1db3a6d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports